import { useMemo, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import 'whatwg-fetch'
// import qs from 'qs'
import { getTypes, getStores, getSlots, getForm, call } from '@api'
// import config from '@config'

export const useApi = ([url, options]) => {
  const [results, setResults] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)

    const controller = call(
      url,
      options,
      (json) => {
        setResults(json)
        setError(null)
        setLoading(false)
      },
      (err) => {
        setError(err)
        setLoading(false)
      }
    )

    return () => {
      if (controller) {
        controller.abort()
      }
    }
  }, [url, options])

  return [results, error, loading]
}

export const useOnClickOutside = (ref, handler) => {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }
        handler(event)
      }
      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)
      return () => {
        document.removeEventListener('mousedown', listener)
        document.removeEventListener('touchstart', listener)
      }
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  )
}

export default useOnClickOutside

export const useGetTypes = () => {
  const request = useMemo(() => getTypes(), [])
  return useApi(request)
}

export const useGetStores = () => {
  const request = useMemo(() => getStores(), [])
  return useApi(request)
}

export const useGetSlots = (branchCode, templateId, mode) => {
  const request = useMemo(
    () => getSlots(branchCode, templateId, mode),
    [branchCode, templateId, mode]
  )
  return useApi(request)
}

export const useGetForm = () => {
  const request = useMemo(() => getForm(), [])
  return useApi(request)
}

export const useFieldLabelByValue = (key, value) => {
  const field = useSelector((s) => s.fields.find((f) => f.field_key === key))
  const option = field?.options?.find((o) => o.value === value)

  return option?.label || value
}
